export default __webpack_public_path__ + "static/media/app-icon-psychflex.d5046ff7.png";